import React from "react";
import PropTypes from "prop-types";
import "./CircleIcon.style.scss";

const CircleIcon = ({ color, label, fullLabel, style, tooltipID }) => {
  return (
    <span
      className="circle-icon"
      data-tip={fullLabel}
      title={fullLabel}
      style={{
        backgroundColor: fullLabel.toLowerCase() === "cash" ? "#008635" : color,
        ...style,
      }}
    >
      {label}
    </span>
  );
};

CircleIcon.defaultProps = {
  color: "#ccc",
};
CircleIcon.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  fullLabel: PropTypes.string.isRequired,
};

export default CircleIcon;



// WEBPACK FOOTER //
// ./src/components/common/treeTableWithSlider/circleIcon/CircleIcon.jsx